import styles from "./styles.module.scss";
//assets
import { ArrowDownIcon } from "../../assets";

export default function DecreaseStatistic({ percent }: { percent: string }) {
  return (
    <div className={styles.statsBody}>
      <div className={styles.arrowBodyDescrease}>
        <ArrowDownIcon width={"10px"} className={styles.arrowUp} />
      </div>
      <p className={styles.decreaseInfo}>{percent}</p>
    </div>
  );
}
